export const mockProjects = [
  {
    id: 1,
    title: "E-Commerce Platform",
    category: "Full Stack",
    description: "A comprehensive e-commerce solution with advanced features including real-time inventory management, secure payment processing, and dynamic product recommendations.",
    technologies: ["React", "Node.js", "Express", "MongoDB", "Stripe", "Redux"],
    features: [
      "User authentication & authorization",
      "Shopping cart & checkout system",
      "Payment gateway integration",
      "Admin dashboard for inventory",
      "Order tracking system"
    ],
    github: "https://github.com",
    demo: "https://demo.example.com"
  },
  {
    id: 2,
    title: "Task Management Dashboard",
    category: "Frontend",
    description: "An intuitive task management interface with drag-and-drop functionality, real-time updates, and collaborative features for team productivity.",
    technologies: ["React", "TypeScript", "Tailwind CSS", "Framer Motion", "Context API"],
    features: [
      "Drag & drop task organization",
      "Real-time collaboration",
      "Custom dashboard widgets",
      "Progress tracking & analytics",
      "Dark/light theme toggle"
    ],
    github: "https://github.com",
    demo: "https://demo.example.com"
  },
  {
    id: 3,
    title: "RESTful API Service",
    category: "Backend",
    description: "A scalable microservices architecture with comprehensive API endpoints, authentication middleware, and detailed documentation.",
    technologies: ["Node.js", "Express", "MongoDB", "JWT", "Docker", "Swagger"],
    features: [
      "JWT-based authentication",
      "Rate limiting & security",
      "API documentation with Swagger",
      "Database optimization",
      "Error handling middleware"
    ],
    github: "https://github.com",
    demo: "https://api.example.com/docs"
  },
  {
    id: 4,
    title: "Social Media Analytics",
    category: "Full Stack",
    description: "A comprehensive analytics platform that aggregates social media metrics, provides insights, and generates automated reports for digital marketing teams.",
    technologies: ["React", "Node.js", "Express", "MongoDB", "Chart.js", "Cron"],
    features: [
      "Multi-platform data aggregation",
      "Interactive data visualizations",
      "Automated report generation",
      "Custom metric tracking",
      "Export functionality"
    ],
    github: "https://github.com",
    demo: "https://demo.example.com"
  },
  {
    id: 5,
    title: "Weather Forecast App",
    category: "Frontend",
    description: "A beautiful weather application with location-based forecasts, interactive maps, and personalized weather alerts with smooth animations.",
    technologies: ["React", "OpenWeather API", "Leaflet", "SCSS", "PWA"],
    features: [
      "Location-based forecasts",
      "Interactive weather maps",
      "7-day forecast display",
      "Weather alerts & notifications",
      "Offline functionality (PWA)"
    ],
    github: "https://github.com",
    demo: "https://demo.example.com"
  },
  {
    id: 6,
    title: "User Authentication Service",
    category: "Backend",
    description: "A robust authentication microservice with multiple login methods, session management, and comprehensive security features for enterprise applications.",
    technologies: ["Node.js", "Express", "MongoDB", "Passport.js", "bcrypt", "Redis"],
    features: [
      "Multi-factor authentication",
      "OAuth2 integration",
      "Session management with Redis",
      "Password encryption & hashing",
      "Audit logging system"
    ],
    github: "https://github.com",
    demo: "https://auth.example.com"
  }
];

export default mockProjects;